import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import InventoryInwardDetail from './components/InventoryInwardDetails.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageInventoryInward',
  components: {
    InventoryInwardDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;